import { Button, ButtonVariant, ButtonColorVariant } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface MembershipTableFooterProps {
  totalSelectedCount: number;
  isSaving: boolean;
  isSaveDisabled?: boolean;
  onClearSelection: () => void;
  onCancel: () => void;
  onSave: () => void;
}

export function MembershipTableFooter({
  totalSelectedCount,
  isSaving,
  isSaveDisabled = false,
  onClearSelection,
  onCancel,
  onSave,
}: MembershipTableFooterProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row items-center justify-between gap-4">
      <div className="flex flex-row items-center gap-4">
        <span className="text-center text-sm font-medium sm:text-left">
          {t("ram:SelectedUsersCount", { count: totalSelectedCount })}
        </span>
        <Button variant={ButtonVariant.Outlined} colorVariant={ButtonColorVariant.Secondary} onClick={onClearSelection}>
          {t("common:ClearSelection")}
        </Button>
      </div>

      <div className="flex flex-row items-center justify-end gap-4">
        <Button variant={ButtonVariant.Outlined} colorVariant={ButtonColorVariant.Secondary} onClick={onCancel}>
          {t("common:Cancel")}
        </Button>
        <Button onClick={onSave} disabled={isSaving || isSaveDisabled}>
          {t("common:Save")}
        </Button>
      </div>
    </div>
  );
}
